/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';
	const newsYearList = () => {
		if($('.js-news-yearList').length) {
			var latest = $('.js-news-latest-year').text();
			var earliest = $('.js-news-earliest-year').text();
			let directoryYear = location.pathname.split('/')[2];
			// optionを追加
			for(var i =latest; i>=earliest; i--) {
				$('.js-news-yearList').append($('<option>').html(i).val(i));
			}
			// 見ている年をselected
			$('.js-news-yearList').val(directoryYear);
			// 選択した年に飛ばす
			$('.js-news-yearList').change(function(){
				location.href = location.pathname.replace(directoryYear, $(this).val());
			});
		}
	}
	newsYearList();
})(window.jQuery, window.FUNCTIONS);